import { productValidationValues } from '../product-validation-translations.constant';


export const translateValueLabels = (name: string, label: string, value: string): {label: string; value: string} => {
  if (productValidationValues && productValidationValues[name] && productValidationValues[name][value]) {
    return {
      label: productValidationValues[name][value],
      value
    };
  }

  return {
    label: label ? label : null,
    value: value ? value : null
  };
};
